"use client";
import React, { useEffect } from "react";
import styles from "./Venderdetail.module.css";
import { FaEnvelope, FaGlobe, FaPhone, FaLinkedin } from "react-icons/fa";
import { useState } from "react";
import ReviewsSection from "../ReviewSection/ReviewsSection";
import WriteReviewSection from "../WriteReviewSection/WriteReviewSection";
import { useNavigate, useParams } from "react-router-dom";
import venderService from "@/service/vender.service";
import chatService from "@/service/chat.service";
import { serviceKeys } from "@/constants/serviceKeys";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from "react-toastify";
import BackButton from "@/components/BackButton";
import defaultProfilePic from "@/assets/default-icon.jpg";
import LoanAppForm from "../../components/LoanApplicationForm";
import Loader from "@/components/Loader";
import ServicesSection from "./ServiceSection";
import ConversationSection from "./StartConversatiom";
import PreapprovalApplication from "./PreapprovalApplication";
import ScheduleCallSection from "../ScheduleCallSection";
import ContactSection from "./ContactSection";
import { Avatar } from "@mui/material";


function VendorDetail() {

  const { vendorId } = useParams();
  const [VendorDetail, setVendorDetail] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchVendor = async () => {
      if (!vendorId) return;

      try {
        const vendor = await venderService.fetchVendorById(vendorId);
        setVendorDetail(vendor);
      } catch (error) {
        console.error("Error fetching vendor:", error);
      }
    };

    fetchVendor();
  }, [vendorId]);

  if (!VendorDetail) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <Loader></Loader>
      </div>
    );
  }

  const updateVendorRating = (updatedVendor) => {
    setVendorDetail(updatedVendor);  // Update state with the new vendor data (including ratings)
  };

  return (
    <div className={styles.container}>
      <ToastContainer />

      <div className={styles.wrapper}>
        <div className={styles.content}>
          <ProfileHeader VendorDetail={VendorDetail} />
          <ContactSection VendorDetail={VendorDetail} />
          <ServicesSection VendorDetail={VendorDetail} />

          {VendorDetail.status === 'approved' && (
            <>
              <ConversationSection VendorDetail={VendorDetail} />
              {VendorDetail.vendor_type === 'Mortgage Broker' && (
                <PreapprovalApplication VendorDetail={VendorDetail} />
              )}
              <ScheduleCallSection VendorDetail={VendorDetail} />
              <ReviewsSection VendorDetail={VendorDetail} />
              <WriteReviewSection
                VendorDetail={VendorDetail}
                updateVendorRating={updateVendorRating}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default VendorDetail;

function ProfileHeader({ VendorDetail }) {
  const [venderdetail, setVenderdetail] = useState(VendorDetail);

  const jobTitles = venderdetail?.work_experience
    ?.map((exp) => exp.job_title) // Only show job titles
    .join(" | "); // Separate with "|"

    const calculateTotalExperience = (experiences) => {
      if (!experiences || !Array.isArray(experiences)) return "0 Years";
    
      let totalMonths = 0;
    
      experiences.forEach((exp) => {
        const start = new Date(exp.starting);
        const end = exp.end ? new Date(exp.end) : new Date(); // handle ongoing job
    
        // Safeguard: if start date is invalid or after end date
        if (isNaN(start.getTime()) || isNaN(end.getTime()) || start > end) return;
    
        const diff =
          (end.getFullYear() - start.getFullYear()) * 12 +
          (end.getMonth() - start.getMonth());
        totalMonths += diff;
      });
    
      const years = Math.floor(totalMonths / 12);
      const months = totalMonths % 12;
      return `${years} Years${months > 0 ? ` ${months} Months` : ""}`;
    };    

  const totalExperience = calculateTotalExperience(
    venderdetail?.work_experience
  );

  return (
    <section className={styles.profileHeader}>
      <div className={styles.column}>
        <Avatar
          src={VendorDetail?.profile_picture?.file_url || defaultProfilePic}
          alt="Broker profile"
          variant="square"
          sx={{
            width: { sm: '12vw', lg: '19vw', xl: '12vw' },
            height: { sm: '14vh', lg: '20vh', xl: '15vh' },
            borderRadius: '4px',
            overflow: 'hidden',
            objectFit: 'cover',
          }}

        />
      </div>
      <div className={styles.infoColumn}>
        <header className={styles.profileInfo}>
          <div>
            <h1 className={styles.name}>
              {venderdetail.first_name} {venderdetail.last_name}
            </h1>
            <h2 className={styles.title}>
              {[venderdetail.professional_title, venderdetail.business_name]
                .filter(Boolean)
                .join(" | ")}
            </h2>
          </div>
          <p className={styles.experience}>
            Experience:{" "}
            <span className={styles.experienceYears}>{totalExperience}</span>
          </p>
          <p className={styles.bio}>
            {venderdetail.description || ''}
            {/* "With over 15 years of experience in the mortgage industry, I am a trusted expert in helping clients secure the best home loan options.I specializes in first-time homebuyer programs, refinancing, and investment property loans. Known for my transparent advice."} */}
          </p>
        </header>
      </div>
      <BackButton></BackButton>
    </section>
  );
}


